export default "/images/ea6fbaa7fac08eede7a0d3227b6843de.avif";